<template>
  <v-form
    ref="form"
    class="mb-2"
    :value="valid"
    @input="v => $emit('update:valid', v)"
  >
    <v-row
      align="center"
      dense
      class="mb-2"
      v-if="est_intermediaire && expiration === false"
    >
      <v-col cols="12">
        <v-checkbox
          hide-details
          v-model="getUseConversionFormulaModel"
          label="Utiliser une mesure différente pour l'inventaire"
        ></v-checkbox>
      </v-col>
    </v-row>
    <section
      v-if="
        getUseConversionFormulaModel === true &&
          est_intermediaire &&
          expiration === false
      "
    >
      <v-row align="center" class="mt-3" dense>
        <v-col cols="6" sm="3">
          <j-decimal-input
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="quantity_inventory"
            label="Quantité d'inventaire"
            :min="0.0001"
            :required="getUseConversionFormulaModel === true"
            @change="v => $emit('update:quantity_inventory', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="6" sm="2">
          <v-autocomplete
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="unite_inventory"
            :rules="[notNull]"
            :items="getAllowedUnits"
            label="Unité de mesure"
            :required="getUseConversionFormulaModel === true"
            @change="v => $emit('update:unite_inventory', v)"
          ></v-autocomplete>
        </v-col>
        <span class="subtitle-1 gutters">équivaut à</span>
        <v-col cols="6" sm="3">
          <j-decimal-input
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="quantity_production"
            label="Quantité de production"
            :required="getUseConversionFormulaModel === true"
            :min="0.0001"
            @change="v => $emit('update:quantity_production', v)"
            :suffix="unite_produite"
          ></j-decimal-input>
        </v-col>
        <span class="subtitle-1 gutters">en inventaire</span>
      </v-row>
      <v-row align="center" no-gutters dense>
        <v-text-field
          dense
          filled
          class="no-before"
          hide-details="auto"
          :value="comments_inventory"
          @change="v => $emit('update:comments_inventory', v)"
          label="Détails additionnels sur la prise d'inventaire"
        ></v-text-field>
      </v-row>
    </section>
    <v-row
      align="center"
      dense
      class="mb-2"
      v-if="est_intermediaire && expiration"
    >
      <v-col cols="12">
        <v-checkbox
          hide-details
          v-model="getUseExpirationDateModel"
          label="Utiliser une durée d'expiration"
        ></v-checkbox>
      </v-col>
    </v-row>
    <section
      v-if="
        getUseExpirationDateModel === true && est_intermediaire && expiration
      "
    >
      <v-row align="center" dense>
        <v-col cols="12" sm="4">
          <j-decimal-input
            hide-details
            filled
            dense
            class="no-before"
            :value="expiration_date_timer"
            :min="0"
            :step="0"
            :decimal="0"
            label="Nombre de jours avant expiration"
            @change="v => $emit('update:expiration_date_timer', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="12" sm="4">
          <j-decimal-input
            hide-details
            filled
            dense
            class="no-before"
            :value="expiration_date_threshold"
            :min="0"
            :step="0"
            :decimal="0"
            label="Nombre de jours avant alerte"
            @change="v => $emit('update:expiration_date_threshold', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="12" sm="4" align-self="center">
          <v-checkbox
            v-model="getUseAutoExpirationWasteModel"
            label="Créer une perte à l'expiration"
          ></v-checkbox>
        </v-col>
      </v-row>
    </section>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import { rulesMixin } from "@/mixins/rulesMixins";
export default {
  mixins: [rulesMixin],
  name: "RecipePriceInput",
  props: {
    quantite_produite: {
      required: true
    },
    unite_produite: {
      required: true
    },
    cost: {
      required: true
    },
    quantity_production: {
      required: true
    },
    quantity_inventory: {
      required: true
    },
    unite_inventory: {
      required: true
    },
    prix_inventory: {
      required: true
    },
    use_conversion_formula: {
      required: true
    },
    comments_inventory: {
      required: true
    },
    is_pinned: {
      required: true
    },
    use_expiration_date: {
      required: true
    },
    expiration_date_timer: {
      required: true
    },
    expiration_date_threshold: {
      required: true
    },
    use_auto_expiration_waste: {
      required: true
    },
    always_produce_quantity: {
      required: true
    },
    est_intermediaire: {
      type: Boolean,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    },
    expiration: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getAllowedUnits"]),
    getUseConversionFormulaModel: {
      get() {
        return this.use_conversion_formula;
      },
      set(v) {
        this.$emit("update:use_conversion_formula", v);
        if (v === false) {
          this.$emit("update:quantity_production", null);
        }
      }
    },
    getIsPinnedModel: {
      get() {
        return this.is_pinned;
      },
      set(v) {
        this.$emit("update:is_pinned", v);
      }
    },
    getUseExpirationDateModel: {
      get() {
        return this.use_expiration_date;
      },
      set(v) {
        this.$emit("update:use_expiration_date", v);
      }
    },
    getUseAutoExpirationWasteModel: {
      get() {
        return this.use_auto_expiration_waste;
      },
      set(v) {
        this.$emit("update:use_auto_expiration_waste", v);
      }
    },
    alwaysProduceQuantityModel: {
      get() {
        return this.always_produce_quantity;
      },
      set(newValue) {
        this.$emit("update:always_produce_quantity", newValue);
      }
    }
  }
};
</script>

<style scoped>
.gutters {
  padding: 4px;
}
</style>
